import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getRawMaterialCollectionList = createAsyncThunk("/raw-material-collectionlist", async (data, { rejectWithValue }) => {
//   const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}rawMaterialCollection/api/v1/list`, data, {
         headers: {
            "Content-Type": "application/json",
          },
      // headers: {
      //   "auth-token": token,
      //   "Content-Type": "application/json",
      // },
    });
    console.log("re response raw material collection------------", response);
    return response.data?.rawMaterials;
  } catch (error) {
    console.error("Error fetching Raw Material Collection", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Raw Material Collection");
  }
});